import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { ApiFetchError } from '@nrdy-marketing-engine/api-fetch/src/api-fetch';
import { Me } from '@nrdy-marketing-engine/cart/@types/me';

import { Client } from '@nrdy-marketing-engine/cart/@types/cart-state';
import { CatalogItem } from '@nrdy-marketing-engine/cart/@types/catalog-item';

export class UserController {
  usersMeGet = () =>
    apiFetch<Me>('/v1/users/me?include_entity=true&include_students=true').catch((err) => {
      if (err instanceof ApiFetchError && err.response.status.toString().startsWith('4')) {
        return null;
      }

      throw err;
    });

  usersMeConvert = () =>
    apiFetch('/v1/users/me/convert', {
      method: 'POST',
      body: JSON.stringify({
        cookies: {
          landing_page: location.href,
          page: location.href,
          referer: document.referrer || `${location.protocol}//${location.hostname}`,
        },
      }),
    }).catch((err) => {
      if (err instanceof ApiFetchError && err.response.status.toString().startsWith('4')) {
        return err;
      }

      throw err;
    });

  createAccount = ({ email, password, firstName, lastName }: Client, catalogItem: CatalogItem) =>
    apiFetch('/v1/users', {
      method: 'POST',
      body: JSON.stringify({
        type: 'ecommerce_checkout',
        email,
        first_name: firstName,
        last_name: lastName,
        password,
        additional_lead_data: {
          lead_form: {
            item_commodity_type: catalogItem?.commodity_type,
            item_id: catalogItem?.id,
            item_price: catalogItem?.price_cents,
          },
        },
        cookies: {
          page: location.href,
          referer: document.referrer || `${location.protocol}//${location.hostname}`,
          landing_page: location.href,
        },
      }),
    });

  signIn = ({ email, password }: { email: string; password: string }) =>
    apiFetch<{ accessToken: string }>('/v1/users/login', {
      method: 'POST',
      body: JSON.stringify({
        email,
        password,
        cookies: { page: location.href, referer: document.referrer, landing_page: location.href },
      }),
    }).catch((err) => {
      if (err instanceof ApiFetchError && err.response.status.toString().startsWith('4')) {
        throw new Error('User not found with this email and password');
      }
      throw new Error('Error occurred during login');
    });
}
